export enum SortValue {
  CheapFirst = "cheap-first",
  ExpensiveFirst = "expensive-first",
  Default = "default",
}

export enum BackendSortQueryParam {
  UnitPrice = "unit_price",
}

export const PINNED_DOWN_FILTERS = ["unit_price"];

export const EXONN_HUB_ORDER_PREVIEW_MODAL_Z_INDEX = 10_000;
export const EXONN_HUB_ORDER_PREVIEW_MODAL_OVERLAY_Z_INDEX =
  EXONN_HUB_ORDER_PREVIEW_MODAL_Z_INDEX - 1;
export const EXONN_HUB_FILTERS_PANEL_Z_INDEX =
  EXONN_HUB_ORDER_PREVIEW_MODAL_OVERLAY_Z_INDEX - 1;
